import Main from "./components/Main";
import "cesium/Build/Cesium/Widgets/widgets.css";
import "./App.css";
import LogIn from "./components/LogIn";
import { useEffect } from "react";
import { getFromCache } from "./utilies/Utility";
import Type from "./utilies/Types";
import SplashScreen from "./components/SplashScreen";
import { useAppStore } from "./context/store";

function App() {
  const isLogedIn = useAppStore((s) => s.isLogedIn);

  const setIsLoggedIn = useAppStore((s) => s.setIsLoggedIn);
  const setUserType = useAppStore((s) => s.setUserType);
  const setUserData = useAppStore((s) => s.setUserData);
  const setUserCanEditing = useAppStore((s) => s.setUserCanEditing);

  useEffect(() => {
    let userInfo = getFromCache(Type.STORAGE.USERINFO);
    if (userInfo != null) {
      setUserData(userInfo);
      setUserType(userInfo.roles);
      if (userInfo.roles.includes(Type.ROLE.ADMIN) || userInfo.roles.includes(Type.ROLE.ANNOTATOR) || userInfo.roles.includes(Type.ROLE.DIGITIZER) || userInfo.roles.includes(Type.ROLE.SUPER_ADMIN)) {
        setUserCanEditing(true);
      } else {
        setUserCanEditing(false);
      }

      setTimeout(() => {
        setIsLoggedIn("true");
      }, 1000);
    } else {
      setIsLoggedIn("false");
    }
  }, []);

  if (isLogedIn == "true") {
    return <Main />;
  } else if (isLogedIn == "false") {
    return <LogIn />;
  } else if (isLogedIn == "loading") {
    return <SplashScreen />;
  }
}

export default App;
